import { MasterAgentDashboardCategory } from '../../enums/master-agent-dashboard-category.enum';

export interface GetUserAgentDealsParams {
  userId: string;
  fromDate?: Date;
  toDate?: Date;
  take?: number;
  skip?: number;
  category?: MasterAgentDashboardCategory;
  orderBy?: string;
  sortOrder?: 'asc' | 'desc';
  includeSelf?: boolean;
  search?: string;
}
